import { render } from "./all-day-bar.vue?vue&type=template&id=1fec77b5&lang=pug"
import script from "./all-day-bar.vue?vue&type=script&lang=js"
export * from "./all-day-bar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__